export const environment = {
    appName: "Navigator",
    apiEndPoint: "https://portal.tmeic.com/",  
    production: true,
    enableConsoleLogs: false,
    logLevel: 'none',   
    redirectUri: 'https://portal.tmeic.com/navigator',
    clientId: '9a80fe5e-32a4-4ccf-8dfd-45b69a9aa627',
    tenantId: '6a3961d2-fc3b-4368-9ddb-90f1018e6bb0',
    cdnBaseUrl: 'https://falling-morning-e5e5.tmeic-corporation-account.workers.dev/',
    apryseWebLicenseKey: 'TMEIC Corporation Americas:OEM:a5jOK000001RzWf::B+3:AMS(20270419):2C7AC2B7267C4E1151B7F1DB2B51414996A8D2C881FF091EF557568AC170F4A0D40154FA656D',
    loqateKey: 'MB68-ZC78-XF96-GB53'
};
